import { ResponseCanal } from "@/services/canais/canais.service";
import { IdInbox } from "@/services/common-types";
import { useAuthStoreUser } from "@/stores/app/authUser";
import { usePermissoesStore } from "@/stores/app/permissoesStore";

/**
 * Canais aos quais o atendente está de fato vinculado (`usuarios_canais`).
 *
 * `authStore.canais` vem do who-am-i escopado à conta atual e o backend o
 * hidrata a cada request por `UsuariosCanaisService.listarPorUsuario` — é a
 * mesma fonte que a guarda de canal usa, então front e backend não divergem.
 * Usuário com acesso global recebe todos os canais da conta nesse mapa, logo
 * não precisa de tratamento especial aqui.
 *
 * Use em SELEÇÃO DE AÇÃO (abrir atendimento, transferir): oferecer canal sem
 * vínculo joga o atendimento na fila de outro time e agora leva a 403 na
 * criação.
 */
export function filtrarCanaisVinculados(canais: ResponseCanal[]): ResponseCanal[] {
    const authStore = useAuthStoreUser();
    return canais.filter(canal => authStore.canais[canal.id] === true);
}

/**
 * Canais cujos atendimentos o usuário realmente enxerga na lista. Espelha
 * `chatStore._podeVerAtendimento`: vínculo com o canal, visualização global no
 * canal ou `inbox.ver_todos_atendimentos` no inbox.
 *
 * Use em FILTRO DE LEITURA: cortar só por vínculo esconderia do supervisor
 * canais cujos atendimentos continuam aparecendo na lista.
 */
export function filtrarCanaisVisiveis(idInbox: IdInbox, canais: ResponseCanal[]): ResponseCanal[] {
    const authStore = useAuthStoreUser();
    const idConta = authStore.currentConta?.id;

    if (idConta && usePermissoesStore().temPermissao('inbox.ver_todos_atendimentos', idConta, idInbox))
        return canais;

    return canais.filter(canal =>
        authStore.canais[canal.id] === true
        || authStore.canaisVisualizacaoGlobal[canal.id] === true
    );
}
